import React from "react";
import styles from "./index.module.scss";
import NotesItem from "./notes-item";
import ItemHeader from "../item-header";
import { useNotesListing } from "../../../../../../hooks/react-query/investor-dashboard/useNotesListing";

interface itemType {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  notes: string;
  isPrivate: boolean;
  accountId: string;
  pubPropertyId: string;
  userId: string;
  deletedAt: null;
  fullName?: string;
}

export default function NotesList({
  accountId,
  propertyId,
  type,
  showActions = false
}: any) {
  const { data: notesData, isLoading } = useNotesListing({
    accountId,
    propertyId,
    type
  });

  if (isLoading) {
    return (
      <div className={styles.timeline}>
        <div className={styles.loadingState}>
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!notesData || notesData.length === 0) {
    return (
      <div className={styles.timeline}>
        <div className={styles.noDataState}>
          <span>No Notes Found</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.timeline}>
      {notesData?.map((item: itemType, index: number) => (
        <div key={index} className={styles.timelineItem}>
          <ItemHeader
            item={item}
            showActions={showActions}
            status={"Added Notes"}
          />
          <NotesItem notes={item.notes} />
        </div>
      ))}
    </div>
  );
}
